import ObservablePropertyDescriptorObject from '../../designer/utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../designer/utils/PropertyDescriptor';

export default class Model extends ObservablePropertyDescriptorObject {

    borderWidth = new PropertyDescriptor(3, '边框宽度', "边框与填充", "double", "#anticon-visualization-border", {
        catalogIndex: 50,
    });

    borderStyle = new PropertyDescriptor('solid', '边框风格', "边框与填充", "enum", "#anticon-border-top", {
        values: [
            new PropertyDescriptor("solid", undefined, "边框风格", "string"),
            new PropertyDescriptor("dashed", undefined, "边框风格", "string"),
            new PropertyDescriptor("dotted", undefined, "边框风格", "string"),
            new PropertyDescriptor("double", undefined, "边框风格", "string"),
            new PropertyDescriptor("groove", undefined, "边框风格", "string"),
            new PropertyDescriptor("inset", undefined, "边框风格", "string"),
            new PropertyDescriptor("outset", undefined, "边框风格", "string"),
            new PropertyDescriptor("ridge", undefined, "边框风格", "string"),
            new PropertyDescriptor("hidden", undefined, "边框风格", "string"),
            new PropertyDescriptor("none", undefined, "边框风格", "string"),
            new PropertyDescriptor("unset", undefined, "边框风格", "string"),
        ]
    });

    borderColor = new PropertyDescriptor('#000000', '边框颜色', "边框与填充", "color", "#anticon-edit3", {
    });

    backgroundColor = new PropertyDescriptor('#00000000', '背景颜色', "边框与填充", "color", "#anticon-a-16_ToolBar_C_BI_beijingyanse_1", {
    });

    onPropertyValueChanged(name, valOld, valNew, subName, args) {
        super.onPropertyValueChanged(name, valOld, valNew, subName, args);

        if (name === "borderStyle" && subName === undefined)
            this.setPropertyVisible("borderWidth", valNew !== "none");
    }

    toStyle() {

        return {
            borderWidth: this.borderWidth,
            borderColor: this.borderColor,
            borderStyle: this.borderStyle,
            backgroundColor: `${this.backgroundColor}`
        }
    }
}
